<template>
	<div class="verificationCode">
		<div class="text_box">
			<div class="title">手机号登录/注册</div>
			<div class="text">未注册的用户验证后将自动注册并登录</div>
		</div>
		<div class="input_Box">
			<input class="my_input" placeholder="请输入手机号" type="tel" maxlength="11" v-model="telNumber"
				@input="handleInput" :focus="isFocused" />
			<div class="input_Box_close" v-if="showClearIcon" @click="clearIcon">
				<img :src="require('@/assets/image/icon/loginClose.png')" alt="close" />
			</div>
		</div>
		<div class="mini_btns" v-if="showBtn == 0">获取验证码</div>
		<div class="mini_btn" @click="goVerification" v-if="showBtn == 1">获取验证码</div>
	</div>
</template>

<script>
export default {
	name: 'VerificationCode',
	props: {
		isInputFocus: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showBtn: 0,
			telNumber: "",
			showClearIcon: false,
			isFocused: false,
		}
	},
	mounted() {
		if (this.isInputFocus) {
			this.onFocus()
		}
		const savedPhone = localStorage.getItem('loginPhoneNumber')
		if (savedPhone) {
			this.telNumber = savedPhone
			this.showBtn = this.telNumber.length === 11 ? 1 : 0
			this.showClearIcon = this.telNumber.length > 0
		}
	},
	methods: {
		onFocus() {
			this.isFocused = true
		},
		goVerification() {
			const regex = /^1[3456789]\d{9}$/
			if (!regex.test(this.telNumber)) {
				this.telNumber = ''
				this.$toast('请输入正确的手机号')
				return
			}
			this.$emit("send", this.telNumber)
		},
		clearIcon() {
			this.telNumber = ""
			this.showBtn = 0
			this.showClearIcon = false
			localStorage.removeItem('loginPhoneNumber')
		},
		handleInput(e) {
			const value = e.target.value
			if (value.length > 0) {
				this.showClearIcon = true
			} else {
				this.showClearIcon = false
			}
			if (value.length > 10) {
				this.showBtn = 1
				localStorage.setItem('loginPhoneNumber', value)
			} else {
				this.showBtn = 0
			}
			if (value.length === 0) {
				this.showBtn = 0
				this.showClearIcon = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.verificationCode {
	.text_box {
		font-size: 0.6rem;
		color: #CACACA;
		padding-bottom: 1.35rem;

		.title {
			font-weight: bold;
			font-size: 0.8rem;
			color: #1D1D1D;
			padding-bottom: 0.3rem;
		}
	}

	.input_Box {
		width: 15rem;
		border-bottom: 0.05rem solid #EEEEEE;
		padding: 0.5rem;
		opacity: 1;
		display: flex;
		align-items: center;
		margin-bottom: 1.25rem;
		position: relative;
		padding-left: 0;

		.my_input {
			width: 8.5rem;
			color: #1D1D1D;
			font-size: 0.8rem;
			flex: 1;
			border: unset !important;

			&::placeholder {
				color: #ccc;
			}
		}

		.input_Box_close {
			width: 2.5rem;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			cursor: pointer;

			img {
				display: block;
				width: 0.6rem;
				height: 0.6rem;
			}
		}
	}

	.mini_btns {
		width: 15rem;
		height: 2.5rem;
		line-height: 2.5rem;
		margin-top: 2.5rem;
		background: #8E8E8E;
		border-radius: 1.25rem;
		font-size: 0.8rem;
		color: #FFFFFF;
		text-align: center;
	}

	.mini_btn {
		width: 15rem;
		height: 2.5rem;
		line-height: 2.5rem;
		margin-top: 2.5rem;
		background: linear-gradient(90deg, #1D1D1D 0%, #5B4E3F 100%);
		border-radius: 1.25rem;
		opacity: 1;
		font-size: 0.8rem;
		color: #FFDB89;
		text-align: center;
		cursor: pointer;
	}
}
</style>